import { required, helpers, minLength } from "@vuelidate/validators";

export default class Project {

    constructor() {
        this.id = null;
        this.name = null;
        this.mainDirectory = null;
        this.path = null;
        this.description = null;
        this.size = null;
        this.dtCreate = null;
        this.dtUpdate = null;
    }
    validations() {
        return {
            name: {
                required,
                minLength: minLength(3),
            },
            mainDirectory: {
                required,
                helpers: helpers.regex(/^[a-z-]+$/)
            },
            description: {
                required,
            },
        };
    }
}